module.exports = __webpack_public_path__ + "img/web3.3f6a72fd.png";